module.exports = __webpack_public_path__ + "img/case-浙江.f2a5ded4.png";